<template>
	<ModalComponent ref="modalRef" :isHeader="false" :isFooter="false" :defaultOpen="false"
		:closeOnBackgroundClick="false">
		<div class="input-otp bg-grey-4 text-center p-5">
			<div class="text-right mb-3">
				<span @click="buttonCloseHandler()" ><IconButtonClose  class="cursor-pointer" /></span>
			</div>

			<div class="mb-3">
				<IconEmail2 v-if="mode == 'email'" />
				<IconSms v-else />
			</div>

			<div class="mb-3">{{ title }}</div>

			<div class="text-xs">{{ text }}</div>

			<div class="text-xs mb-8">{{ contact }}</div>

			<div class="mb-5">
				<input class="input w-full text-center" type="text" placeholder="Masukkan kode OTP" maxlength="6" v-model="otp" @keypress="onlyNumbers">
			</div>

			<div class="mb-5">
				<button class="btn c-btn-theme w-full" :disabled="disableSubmit" @click="submit()">Lanjut</button>
			</div>

			<div v-if="timer != null" class="text-sm color-theme">Kirim ulang kode OTP dalam {{ timer }}</div>
			<div v-else class="text-sm text-theme cursor-pointer" @click="resendOtp()">Kirim ulang kode OTP</div>
		</div>
	</ModalComponent>
</template>

<script>
import ModalComponent from '../../../components/ModalComponent.vue'

import IconEmail2 from '../../../components/icons/IconEmail2.vue';
import IconSms from '../../../components/icons/IconSms.vue';
import IconButtonClose from '../../../components/icons/IconButtonClose.vue';

import { createCountdown } from '../../../utils/timer'

export default {
	name: 'InputOtp',

	components: {
		ModalComponent,
		IconEmail2,
		IconSms,
		IconButtonClose
	},

	props: {
		titleDefault: {
			type: String,
			default: 'Kode OTP Via Email',
		},

		textDefault: {
			type: String,
			default: 'Silakan masukkan kode OTP yang kami kirimkan melalui email Anda',
		},

		contactDefault: {
			type: String,
			default: 'email@gmail.com',
		},

		// time before to be able to resend OTP. In second.
		nextResendTime: {
			type: Number,
			default: 60,
		}
	},

	data() {
		return {
			titleForce: null,
			textForce: null,
			contactForce: null,
			otp: '',
			timer: null,
			mode: 'email', // email or sms
		}
	},

	computed: {
		title() {
			if (this.titleForce) {
				return this.titleForce
			}

			return this.titleDefault
		},

		text() {
			if (this.textForce) {
				return this.textForce
			}

			return this.textDefault
		},

		contact() {
			if (this.contactForce) {
				return this.contactForce
			}

			return this.contactDefault
		},

		disableSubmit() {
			if (this.otp.length < 6) {
				return true
			}

			return false
		}
	},

	methods: {
		openInputOtp() {
			this.$refs.modalRef.openModal()
		},

		closeInputOtp() {
			this.$refs.modalRef.closeModal()
		},

		buttonCloseHandler() {
			console.log('buttonCloseHandler')
			this.$emit('close')
		},

		setTitle(title) {
			this.titleForce = title
		},

		setText(text) {
			this.textForce = text
		},

		setContact(contact) {
			this.contactForce = contact
		},

		/**
		 * Set the mode of OTP
		 * @param {'email'|'sms'} mode
		 */
		setMode(mode) {
			this.mode = mode
		},

		clearOtp() {
			this.otp = ''
		},

		startTimer(time = this.nextResendTime) {
			return createCountdown(
				time,
				(time2) => {
					this.timer = time2
				}, () => {
					this.timer = null
				}
			)
		},

		submit() {
			//emit event to parent component
			this.$emit('submit', this.otp)
		},

		resendOtp() {
			this.$emit('resend')
			this.startTimer()
		},

		onlyNumbers(event) {
			if (!/[0-9]/.test(event.key)) {
				event.preventDefault()
			}
		}
	}
}
</script>

<style scoped>
.input-otp {
	max-width: 25rem;
	min-width: 25rem;
}
</style>